"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const theme_1 = require("./theme");
const inputStyle = {
    width: '100%',
    padding: theme_1.theme.spacing.inputPadding,
    marginBottom: 12,
    border: `2px solid ${theme_1.theme.colors.inputBorder}`,
    borderRadius: theme_1.theme.radii.input,
    background: theme_1.theme.colors.input,
    color: theme_1.theme.colors.text,
    fontSize: 16,
    boxSizing: 'border-box',
};
exports.Input = react_1.default.forwardRef(({ style, ...rest }, ref) => ((0, jsx_runtime_1.jsx)("input", { ref: ref, style: { ...inputStyle, ...style }, ...rest })));
exports.Input.displayName = 'Input';
exports.default = exports.Input;
